// MB-I18N-2A / MB-I18N-POS — pos EN (flat keys, strict parity with FR).
export default {
  "pos.tab.online_orders": "Online Orders",
  "pos.tab.register": "Register",

  // POS generics
  "pos.loading": "Loading the register...",
  "pos.total": "Total",
  "pos.qr": "QR",
  "pos.time_min": "{time} min",
  "pos.items_count": "{count} item(s)",
  "pos.orders_count": "{count} order(s)",
  "pos.points_pts": "{count} pts",

  // Actions
  "pos.action.view": "View",
  "pos.action.receipt": "Receipt",
  "pos.action.pay": "Pay",
  "pos.action.recharge": "Top up",
  "pos.action.add": "Add",
  "pos.action.in_cart": "In cart",
  "pos.action.clear_cart": "Clear cart",
  "pos.action.validate_reward": "Validate reward",
  "pos.action.view_recipe": "View recipe",
  "pos.action.pause": "Pause",
  "pos.action.resume": "Resume",
  "pos.action.collapse": "Collapse",
  "pos.action.close": "Close",
  "pos.action.print": "Print",
  "pos.action.mark_ready": "Mark ready",
  "pos.action.complete_credit": "Complete & credit points",
  "pos.action.validate_exchange": "Validate exchange",
  "pos.action.link_customer": "Link customer",
  "pos.action.link_loyalty_card": "Link loyalty card",
  "pos.action.add_to_cart": "Add to cart",

  // Header / menu
  "pos.header.register_default": "Cash register",
  "pos.header.prep_screen": "Preparation screen",
  "pos.role.owner": "Owner",
  "pos.role.manager": "Manager",
  "pos.role.barista": "Barista",
  "pos.role.team": "Team",
  "pos.menu.actions_title": "Register actions",
  "pos.menu.tools": "Tools",
  "pos.menu.customer_mode": "Customer mode",
  "pos.menu.help": "Help",
  "pos.menu.service": "Service",
  "pos.menu.refresh_orders": "Refresh orders",
  "pos.menu.last_receipt": "Last receipt",
  "pos.menu.closure": "Cash closure",
  "pos.menu.back_cockpit": "Back to Cockpit",
  "pos.menu.logout": "Log out",

  // Shop picker
  "pos.shop_picker.title": "Select your shop",

  // Categories (Workspace tabs)
  "pos.category.chaud": "Hot",
  "pos.category.froid": "Cold",
  "pos.category.cookies": "Cookies",
  "pos.category.plats": "Dishes",
  "pos.category.boulangerie": "Bakery",
  "pos.category.boissons": "Drinks",

  // Workspace
  "pos.plan.price_todefine": "Price to set",
  "pos.plan.priority": "Priority",
  "pos.plan.search_placeholder": "Search a product...",
  "pos.plan.empty_category": "No product in this category",
  "pos.plan.unpriced_one": "{count} product has no price yet. Set it in Menu > Products before selling it.",
  "pos.plan.unpriced_many": "{count} products have no price yet. Set them in Menu > Products before selling them.",

  // Loyalty (register panel)
  "pos.loyalty.card": "Loyalty card",
  "pos.loyalty.identify_customer": "Identify a customer",
  "pos.loyalty.scan_card": "Scan loyalty card",
  "pos.loyalty.enter_code_placeholder": "Enter customer code (SK-XXXX)",
  "pos.loyalty.rewards_title": "Loyalty rewards",
  "pos.loyalty.rewards_hint": "The customer earns points at checkout",
  "pos.loyalty.vip": "VIP",
  "pos.loyalty.balance": "Balance",
  "pos.loyalty.points": "Points",
  "pos.loyalty.requested_rewards": "Requested rewards",
  "pos.loyalty.points_count": "{count} points",
  "pos.loyalty.points_on_completion": "+{points} points on completion",
  "pos.loyalty.loyalty_badge": "Loyalty",
  "pos.loyalty.points_pending": "Loyalty points on completion",

  // Rewards
  "pos.rewards.exchange": "Redeem reward",
  "pos.rewards.dialog_title": "Redeem a reward",
  "pos.rewards.none": "No reward available",
  "pos.rewards.one_max": "Only 1 reward per order",

  // Consumption mode (FR shops)
  "pos.consumption.dine_in": "Dine in",
  "pos.consumption.takeaway": "Takeaway",

  // Cart
  "pos.cart.empty_title": "Empty cart",
  "pos.cart.empty_hint": "Click a product to add it to the ticket.",
  "pos.cart.test_hint_prefix": "No customer needed for a test sale. Just select a product then click ",
  "pos.cart.free_badge": "FREE",
  "pos.cart.total_items": "Total ({count} items)",
  "pos.cart.reward_with_order": "The free reward will be validated with the order.",

  // Orders (view + states)
  "pos.orders.tab_new": "New",
  "pos.orders.tab_ready": "Ready",
  "pos.orders.history": "History",
  "pos.orders.history_title": "Open order history in the Cockpit",
  "pos.orders.empty_pending": "No new order",
  "pos.orders.empty_preparing": "No order in preparation",
  "pos.orders.empty_ready": "No ready order",
  "pos.orders.more_items": "+{count} more",

  // Statuses
  "pos.status.pending": "Pending",
  "pos.status.preparing": "Preparing",
  "pos.status.ready": "Ready",
  "pos.status.completed": "Completed",

  // Payment
  "pos.payment.title": "Payment - {amount}",
  "pos.payment.cash": "Cash",
  "pos.payment.wallet": "Wallet",
  "pos.payment.wallet_short": "Wallet",
  "pos.payment.card_tpe": "Card (POS terminal)",
  "pos.payment.paid_card": "Paid by card",
  "pos.payment.paid_wallet": "Paid by wallet",
  "pos.payment.paid_cash": "Paid cash",
  "pos.payment.paid": "Paid",
  "pos.payment.unpaid": "Unpaid",
  "pos.payment.pending": "Payment pending",
  "pos.payment.required_before_complete": "Payment required before completing",
  "pos.payment.amount_received": "Amount received ({currency})",
  "pos.payment.amount_in": "Amount in {currency}",
  "pos.payment.change_label": "Change due",
  "pos.payment.exact_amount": "Exact amount ({amount})",
  "pos.payment.insufficient_balance_excl": "Insufficient balance!",
  "pos.payment.confirm": "Confirm payment",

  // Receipt
  "pos.receipt.total_ht": "Subtotal (excl. tax)",
  "pos.receipt.vat": "VAT ({rate}%)",
  "pos.receipt.total_ttc": "Total (incl. tax)",
  "pos.receipt.total": "TOTAL",
  "pos.receipt.cash_received": "Cash received",
  "pos.receipt.change_given": "Change given",
  "pos.receipt.customer": "Customer: {name}",
  "pos.receipt.thanks": "Thank you for your visit!",

  // Wallet top-up
  "pos.recharge.title": "Top up wallet",
  "pos.recharge.current_balance": "Current balance: {balance}",
  "pos.recharge.amount": "Amount to top up ({currency})",
  "pos.recharge.amount_placeholder": "Amount",

  // Preparation time
  "pos.prep_time.title": "Preparation time",
  "pos.prep_time.select": "Select the estimated preparation time:",
  "pos.prep_time.minutes": "minutes",

  // Welcome offer
  "pos.welcome_offer.title": "Welcome offer!",
  "pos.welcome_offer.free_espresso": "1 Espresso FREE",
  "pos.welcome_offer.ok": "Great!",

  // Card payment (POS terminal)
  "pos.card_payment.title": "Card payment (POS terminal)",
  "pos.card_payment.ref_label": "POS terminal receipt reference (optional)",
  "pos.card_payment.ref_placeholder": "e.g. TPE_123456",
  "pos.card_payment.hint": "Use the POS terminal to collect the payment, then confirm here.",
  "pos.card_payment.confirm": "Confirm card payment",

  // Attach customer
  "pos.attach.title": "Link customer to order",
  "pos.attach.loyalty_note": "Loyalty points",
  "pos.attach.code_label": "Customer loyalty card code",
  "pos.attach.code_placeholder": "SK-XXXXXXXX",
  "pos.attach.hint": "Scan the card or ask the customer for the code (visible in their wallet).",

  // Loyalty scanner
  "pos.loyalty_scanner.scan": "Scan",
  "pos.loyalty_scanner.manual": "Manual entry",
  "pos.loyalty_scanner.activate_camera": "Enable camera",
  "pos.loyalty_scanner.frame_hint": "Place the loyalty card QR code within the frame",
  "pos.loyalty_scanner.or_code_placeholder": "Or enter the code SK-XXXX",
  "pos.loyalty_scanner.code_label": "Loyalty card code",
  "pos.loyalty_scanner.manual_hint": "The code is on the customer's loyalty card or in their wallet app.",

  // Exchanges to validate (drawer)
  "pos.redemptions.title": "Exchanges to validate",
  "pos.redemptions.description": "Rewards requested by your customers, awaiting counter validation.",
  "pos.redemptions.points_balance": "Points balance",
  "pos.redemptions.requested_at": "Requested",
  "pos.redemptions.insufficient_now": "Insufficient points at this time",

  // Cash closure
  "pos.closure.title": "Cash closure",
  "pos.closure.generated_at": "Generated on {date}",
  "pos.closure.no_orders": "No paid order for this date",
  "pos.closure.export_pdf": "Export PDF",
  "pos.closure.pdf_date": "Date: {date}",
  "pos.closure.pdf_generated": "Generated on: {datetime}",
  "pos.closure.pdf_details": "Payment details",
  "pos.closure.pdf_footer": "Automatically generated by Superkawa POS.",
  "pos.closure.pdf_exported": "PDF exported: {file}",
  "pos.closure.pdf_error": "Error while exporting PDF",

  // Product options
  "pos.options.title": "Options",
  "pos.options.size": "Size",
  "pos.options.unit_price": "Unit price",
  "pos.options.option": "Option",
  "pos.options.vanilla_ice": "Vanilla ice cream",

  // Recipe
  "pos.recipe.title": "Recipe",
  "pos.recipe.loading": "Loading…",
  "pos.recipe.difficulty": "Difficulty:",
  "pos.recipe.ingredients": "Ingredients",
  "pos.recipe.steps": "Steps",
  "pos.recipe.tip": "TIP",

  // Customer view (overlay)
  "pos.customer_view.card_bank": "Bank card",
  "pos.customer_view.paid": "Payment received — Thank you!",
  "pos.customer_view.awaiting": "Awaiting payment",
  "pos.customer_view.welcome": "Welcome",
  "pos.customer_view.order_here": "Your order will appear here",

  // Orders mini-queue
  "pos.miniqueue.empty": "No order in progress",
  "pos.miniqueue.in_progress": "In progress",
  "pos.miniqueue.to_process": "To process",
  "pos.miniqueue.link": "Link",
  "pos.miniqueue.link_title": "Link a loyalty card",
  "pos.miniqueue.collect": "Collect",
  "pos.miniqueue.collect_title": "Collect this order",
  "pos.miniqueue.card_tpe": "Card (POS terminal)",
  "pos.miniqueue.choose_preptime": "Choose preparation time",
  "pos.miniqueue.more": "+{count} more",
  "pos.miniqueue.just_now": "just now",
  "pos.miniqueue.minutes_short": "{count} min",
  "pos.miniqueue.hours_short": "{count} h",
  "pos.miniqueue.status_pending": "New",
  "pos.miniqueue.status_preparing": "Preparing",
  "pos.miniqueue.status_ready": "Ready",
  "pos.miniqueue.action_prepare": "Prepare",
  "pos.miniqueue.action_ready": "Ready",
  "pos.miniqueue.action_finish": "Finish",

  // Toasts / frontend messages
  "pos.toast.load_error": "Error loading data",
  "pos.toast.new_order": "New order",
  "pos.toast.validation_error": "Validation error",
  "pos.toast.service_paused": "Service paused",
  "pos.toast.service_resumed": "Service resumed",
  "pos.toast.status_change_error": "Error while changing status",
  "pos.toast.closed_by_manager": "This store was closed by a manager — only an owner or manager can reopen it",
  "pos.toast.price_undefined": "Price to set — set the price in Admin > Products before selling",
  "pos.toast.reward_not_editable": "Reward not editable. Cancel the order to remove it.",
  "pos.toast.recipe_unavailable": "Recipe unavailable",
  "pos.toast.no_active_shop": "Active shop not found — sign in again or select a shop",
  "pos.toast.customer_not_found": "Customer not found",
  "pos.toast.one_reward_max": "Only 1 reward per order",
  "pos.toast.insufficient_points": "Insufficient points",
  "pos.toast.redeem_error": "Redemption error",
  "pos.toast.reward_added": "{name} added to the ticket",
  "pos.toast.invalid_code": "Invalid code",
  "pos.toast.camera_error": "Unable to access the camera",
  "pos.toast.card_payment_error": "Card payment error",
  "pos.toast.payment_collected": "Payment collected",
  "pos.toast.payment_error": "Payment error",
  "pos.toast.no_shop_selected": "No active shop selected",
  "pos.toast.loading_error": "Loading error",
  "pos.toast.no_data_export": "No data to export",
  "pos.toast.empty_cart": "Empty cart",
  "pos.toast.customer_required_wallet": "Customer required for wallet payment",
  "pos.toast.insufficient_balance": "Insufficient balance",
  "pos.toast.sale_completed": "Sale completed · #{number}",
  "pos.toast.reward_validated": "Reward validated",
  "pos.toast.reward_validation_error": "Reward validation error",
  "pos.toast.wallet_recharged": "Wallet topped up by {amount}",
  "pos.toast.recharge_error": "Top-up error",
  "pos.toast.order_accepted": "Order accepted - {min} min",
  "pos.toast.update_error": "Update error",
  "pos.toast.order_completed_points": "Order completed! +{points} loyalty points",
};
